import { Link } from "react-router-dom";
import { Home, Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { useSettings } from "../hooks/useSettings";

const Footer = () => {
  const { data: s } = useSettings();
  const wa = `https://wa.me/${(s?.whatsapp || "").replace(/[^0-9]/g, "")}`;

  return (
    <footer className="bg-stone-950 text-stone-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-brand text-white"><Home size={20} /></span>
            <span className="font-heading text-xl text-white">{s?.firm_name || "Satyam Real Estate"}</span>
          </div>
          <p className="text-sm leading-relaxed text-stone-400 max-w-md">{s?.about}</p>
        </div>
        <div>
          <h4 className="text-white font-heading text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/properties" className="hover:text-brand transition-colors">All Properties</Link></li>
            <li><Link to="/properties?listing_type=sale" className="hover:text-brand transition-colors">Properties for Sale</Link></li>
            <li><Link to="/properties?listing_type=rent" className="hover:text-brand transition-colors">Properties for Rent</Link></li>
            <li><Link to="/contact" className="hover:text-brand transition-colors">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-heading text-lg mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 text-brand" /><span>{s?.address}</span></li>
            <li className="flex items-center gap-2.5"><Phone size={16} className="text-brand" /><a href={`tel:${s?.phone}`} className="hover:text-brand">{s?.phone}</a></li>
            <li className="flex items-center gap-2.5"><Mail size={16} className="text-brand" /><a href={`mailto:${s?.email}`} className="hover:text-brand break-all">{s?.email}</a></li>
            <li className="flex items-center gap-2.5"><MessageCircle size={16} className="text-brand" /><a href={wa} target="_blank" rel="noreferrer" className="hover:text-brand">WhatsApp Us</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800 py-6 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} {s?.firm_name || "Satyam Real Estate"}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
